import React from "react";
import Card from "react-bootstrap/Card";
import { BsFillPeopleFill } from "react-icons/bs";
import { FiPlus } from "react-icons/fi";
import { useNavigate } from "react-router-dom";
import { IoReturnUpBackOutline } from "react-icons/io5";
import AddAdminstration from "./addadministration";
import ViewAdministration from "./viewadministration";
import { useTranslation } from "react-i18next";

function AdministrationLookup({title ,clientSideupdate ,setClientUpdateon,id}) {
  const [addcustomer, setAddCustomer] = React.useState(false);

  
  const navigate = useNavigate();
     const [administrationclient,setAdministrationclient] = React.useState("")
     
    const setClientAdministrationId=(idx)=>{
       setAdministrationclient(idx)
    }
    const backHandler=()=>{
      if(id){
        setAddCustomer(false);
        setAdministrationclient("")
      }
     else{
      setAddCustomer(false);
      navigate("/clients/administration")
     }
    }
    const { t } = useTranslation("global");

  return (
    <Card className="mt-3">
      <Card.Header>
    {!addcustomer ? (
      <div className="d-flex m-2 justify-content-between align-items-center">
      <p className="align-items-center h6 fs-12  mt-2">
          {" "}
          <BsFillPeopleFill size={20} className="me-2" />
          
          {t("Projets")}
        </p>
        <button
          className="btn btn-primary btn-sm"
          onClick={() => setAddCustomer(true)}
        >
          <FiPlus size={20} className="me-2" /> {t("Ajouter Projets")}
        </button>
      </div>
    ) : (

      <div className="d-flex justify-content-start m-2">
      <button
          className="btn btn-primary btn-sm"
          onClick={backHandler}
        >
          {" "}
          <IoReturnUpBackOutline className="me-1" size={20} />
          {t("Retour")}
        </button>
      </div>
     
    )}
</Card.Header>
    <Card.Body>{addcustomer  && !clientSideupdate ? <AddAdminstration setAddCustomer={setAddCustomer} id={id} 
    administrationclient={administrationclient}
    /> : <ViewAdministration  id={id}
    setAddCustomer={setAddCustomer}
    setClientAdministrationId={setClientAdministrationId}
    />}</Card.Body>
  </Card>
  )
}

export default AdministrationLookup